import { useContext } from 'react';
import { DataContractEditorContext } from './DataContractEditorContext';

export const useDataContractEditorContext = () =>
  useContext(DataContractEditorContext);
